<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <Header></Header>
    
    
    <div class="article-wrapper">

      <div v-if="data.image" class="banner">
        <img class="article-img" :src="ImageUrl+data.image"/>
      </div>
      <div class="title">{{ data.title }}</div>
      <div class="body">
        <div v-html="data.body"></div>
      </div>

    </div>


    <Footer></Footer>
    

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'Article',
  components:{
    Header,
    Footer
  },
  data : () => ({
    data:{}
  }),
  methods:{
    getData(slug){
      this.activeLoading(1)
      this.$axios.get(`article/`+slug)
      .then(res => {
        this.activeLoading(0)
          this.data = res.data.data
      })
      .catch(err => {
        this.activeLoading(0)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    window.scrollTo(0, 0);
    if(this.$route.params.slug !== ''){
      this.getData(this.$route.params.slug)
    }else{
      this.$router.push({name:'Home'});
    }
  }
}
</script>
<style scoped>
.article-wrapper{
  width: 100%;
  max-width: 700px;
  padding: 14px;
  margin: auto;
  margin-bottom: 100px;
  overflow: hidden;
  background: #fff;
  border-radius: 2rem;
}
.banner{
  height: 300px;
  width: 100%;
}
.banner img{
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.article-wrapper .title{
  font-size: 2.5rem;
}
.article-img{
  border-radius: 15px;
}
</style>